export class BarcodeStatistics {
  constructor(public printed: number, public bought: number) {}

  public static clone(statistics: BarcodeStatistics): BarcodeStatistics {
    return new BarcodeStatistics(statistics.printed, statistics.bought);
  }

  // removed backend db structure
}

























































